import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 24,
	viewBox: "0 0 29 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8 0.75H20.7893L27.2502 7.20996V20C27.2502 21.7949 25.7951 23.2499 24.0002 23.25H12.8C11.0051 23.25 9.55005 21.7949 9.55005 20V4C9.55005 2.20507 11.0051 0.75 12.8 0.75Z",
			stroke: "#D4D4D8",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.8 0.299805V3.1998C20.8 5.40894 22.5909 7.1998 24.8 7.1998H27.7",
			stroke: "#D4D4D8",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 7.6001,
			width: 26,
			height: 16,
			rx: 2,
			fill: "#E11D48"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.8323 19.6001V12.3274H6.70162C7.25323 12.3274 7.72316 12.4327 8.11142 12.6434C8.49967 12.8518 8.7956 13.1418 8.9992 13.5134C9.20517 13.8828 9.30815 14.3089 9.30815 14.7919C9.30815 15.2748 9.20398 15.7009 8.99565 16.0703C8.78732 16.4396 8.48547 16.7272 8.09011 16.9332C7.69712 17.1392 7.22127 17.2421 6.66255 17.2421H4.83372V16.0099H6.41397C6.7099 16.0099 6.95375 15.959 7.14551 15.8572C7.33964 15.753 7.48405 15.6098 7.57875 15.4275C7.67581 15.2429 7.72434 15.031 7.72434 14.7919C7.72434 14.5504 7.67581 14.3397 7.57875 14.1598C7.48405 13.9775 7.33964 13.8366 7.14551 13.7372C6.95138 13.6354 6.70517 13.5845 6.40687 13.5845H5.36994V19.6001H3.8323ZM12.885 19.6001H10.3069V12.3274H12.9063C13.6379 12.3274 14.2676 12.473 14.7955 12.7642C15.3235 13.053 15.7295 13.4685 16.0136 14.0106C16.3 14.5527 16.4433 15.2014 16.4433 15.9566C16.4433 16.7142 16.3 17.3652 16.0136 17.9098C15.7295 18.4543 15.3211 18.8721 14.7884 19.1633C14.2581 19.4545 13.6237 19.6001 12.885 19.6001ZM11.8445 18.2826H12.8211C13.2757 18.2826 13.658 18.2021 13.9681 18.0411C14.2806 17.8778 14.515 17.6257 14.6713 17.2848C14.8299 16.9415 14.9092 16.4988 14.9092 15.9566C14.9092 15.4192 14.8299 14.9801 14.6713 14.6392C14.515 14.2983 14.2818 14.0473 13.9717 13.8863C13.6615 13.7253 13.2792 13.6448 12.8247 13.6448H11.8445V18.2826ZM17.5823 19.6001V12.3274H22.3976V13.5951H19.1199V15.3281H22.078V16.5958H19.1199V19.6001H17.5823Z",
			fill: "#E4E4E7"
		})
	]
});
export default SvgPdf;
